/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { TARGET_PLATFORMS } from 'cio/models/action';
import actionInfo from 'cio/utils/action-info';

@tagName('')
export default class Platform extends Component {
  @service push;

  // external API
  actionAbstract = null;

  isSaving = false;

  @computed('actionAbstract.action.{isSplitTest,info,splitActions.@each.type}')
  get _actionInfo() {
    if (!this.actionAbstract.action.isSplitTest) {
      return this.actionAbstract.action.info;
    }

    let splitActionTypes = (this.get('actionAbstract.action.splitActions') || []).map((item) =>
      item.action.get('type'),
    );
    let areAllSplitActionTypesTheSame = splitActionTypes.every((type) => type === splitActionTypes[0]);

    if (!areAllSplitActionTypesTheSame) {
      return null;
    }

    return actionInfo(splitActionTypes[0]);
  }

  _targetPlatforms = TARGET_PLATFORMS;

  @computed('_actionInfo.showTargetPlatform', 'push.platforms.length')
  get _showTargetPlatform() {
    return this._actionInfo.showTargetPlatform && this.push.platforms.length > 1;
  }
}
